module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Light.da11d536.woff2";